import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import Scene from './Scene';
import {
  crossScreenMarginBottom,
  crossScreenPaddingBottom,
  crossScreenPaddingTop,
  toVw,
  toVwMobile,
  toVwTablet,
} from '../utils/styles';
import TitleBig from '../components/TitleBig';
import Container from '../components/Container';
import Indent from '../components/Indent';
import mq from '@/utils/media-queries';

const SceneDocument = styled(Scene)`
  ${crossScreenPaddingTop(252)};
  ${crossScreenPaddingBottom(274)};

  ${mq.tablet(css`
    padding-bottom: ${toVwTablet(253)};
  `)};

  ${mq.mobile(css`
    padding-bottom: ${toVwMobile(231)};
  `)};
`;

const Title = styled(TitleBig)`
  ${crossScreenMarginBottom(190)};
`;

export const Preface = styled.p`
  ${crossScreenMarginBottom(72)};
  font-weight: 400;
`;

export const List = styled.div`
  width: ${toVw(774)};
  font-weight: 400;

  ${mq.tablet(css`
    width: ${toVwTablet(560)};
  `)};

  ${mq.mobile(css`
    width: auto;
  `)};
`;

export const ListItem = styled.div`
  margin-bottom: ${toVw(44)};
  ${crossScreenMarginBottom(44)};

  &:last-child {
    margin-bottom: 0;
  }
`;

export const ListItemTitle = styled.div`
  ${crossScreenMarginBottom(18)};
  color: ${props => props.theme.colorMinor};
`;

const Document = ({ title, children, ...rest }) => (
  <SceneDocument {...rest}>
    <Container>
      <Indent>
        <Title>{title}</Title>
        {children}
      </Indent>
    </Container>
  </SceneDocument>
);

Document.propTypes = {
  title: PropTypes.string.isRequired,
};

export default Document;



// WEBPACK FOOTER //
// ./src/scenes/Document.js